(() => {
  const articleExtLinksNewTab = () => {
    const currentURL = window.location.href;

    if (!currentURL.includes('/article') && !currentURL.includes('/press-release')) return;

    const article = document.querySelector('.article');
    if (!article) return;

    const domains = ['icandecide.org', 'staging.icandecide.org', 'localhost:3000', 'localhost:8000'];
    const links = article.querySelectorAll('a');

    const hasDomain = (string) => domains.map((domain) => string.includes(domain)).includes(true);

    links.forEach((link) => {
      const linkURL = link.href;
      if (!linkURL) return;

      if (!hasDomain(linkURL) && !link.getAttribute('target')) {
        link.setAttribute('target', '_blank');
      }
    });
  };
  articleExtLinksNewTab();

  const articleFeaturedImage = () => {
    const articleBody = document.querySelector('.article__content-body.--wysiwyg.post-article');
    if (articleBody === null) return;

    const firstChild = articleBody.firstElementChild;
    if (firstChild.classList.contains('wp-block-file')) return;
    const secondChild = firstChild.nextElementSibling;
    articleBody.insertBefore(secondChild, firstChild);
  };
  articleFeaturedImage();
})();
